import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/test",
    component: () =>
      import(/* webpackChunkName: "layout" */ "../views/Test.vue"),
  },
  {
    path: "/login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
  },
  {
    path: "/admin",
    component: () =>
      import(/* webpackChunkName: "admin" */ "../views/admin/AdminLayout.vue"),
    children: [
      {
        path: "",
        redirect: "/admin/graphs",
      },
      {
        path: "graphs",
        name: "AdminGraphs",
        component: () =>
          import(
            /* webpackChunkName: "admin-graphs" */ "../views/admin/GraphManage.vue"
          ),
      },
      {
        path: "entity-categories",
        name: "AdminEntityCategories",
        component: () =>
          import(
            /* webpackChunkName: "admin-entity-categories" */ "../views/admin/EntityCategoryManage.vue"
          ),
      },
      {
        path: "relationship-categories",
        name: "AdminRelationshipCategories",
        component: () =>
          import(
            /* webpackChunkName: "admin-relationship-categories" */ "../views/admin/RelationshipCategoryManage.vue"
          ),
      },
      {
        path: "entities",
        name: "AdminEntities",
        component: () =>
          import(
            /* webpackChunkName: "admin-entities" */ "../views/admin/EntityList.vue"
          ),
      },
      {
        path: "entities/new",
        redirect: "/admin/entities",
      },
      {
        path: "entities/:id/edit",
        name: "AdminEntityEdit",
        component: () =>
          import(
            /* webpackChunkName: "admin-entity-detail" */ "../views/admin/AdminEntityDetail.vue"
          ),
      },
      {
        path: "entities/:id",
        name: "AdminEntityDetail",
        component: () =>
          import(
            /* webpackChunkName: "admin-entity-detail" */ "../views/admin/AdminEntityDetail.vue"
          ),
      },
    ],
  },
  {
    path: "/",
    name: "Layout",
    redirect: "/search",
    component: () =>
      import(/* webpackChunkName: "layout" */ "../views/Layout.vue"),
    children: [
      /**搜索页 */
      {
        path: "/search",
        name: "Search",
        component: () =>
          import(/* webpackChunkName: "search" */ "../views/Search.vue"),
      },
      /**图谱页 */
      {
        path: "/graph",
        name: "Graph",
        component: () =>
          import(/* webpackChunkName: "graph" */ "../views/Graph.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
